import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import BookingPage from './pages/BookingPage';
import CheckoutPage from './pages/CheckoutPage';
import NavigationHeader from './components/NavigationHeader';
import WireframeHomePage from './pages/WireframeHomePage';
import WireframeServicesPage from './pages/WireframeServicesPage';
import WireframeBookingPage from './pages/WireframeBookingPage';
import WireframeCheckoutPage from './pages/WireframeCheckoutPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Wireframe Routes (no header) */}
        <Route path="/wireframe" element={<WireframeHomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/wireframe/services" element={<WireframeServicesPage data-id="element-5" />} data-id="element-4" />
        <Route path="/wireframe/booking" element={<WireframeBookingPage data-id="element-7" />} data-id="element-6" />
        <Route path="/wireframe/checkout" element={<WireframeCheckoutPage data-id="element-9" />} data-id="element-8" />

        {/* Final Prototype Routes */}
        <Route path="/*" element={<div className="min-h-screen bg-white" data-id="element-11">
              <NavigationHeader data-id="element-12" />
              <Routes data-id="element-13">
                <Route path="/" element={<HomePage data-id="element-15" />} data-id="element-14" />
                <Route path="/services" element={<ServicesPage data-id="element-17" />} data-id="element-16" />
                <Route path="/booking" element={<BookingPage data-id="element-19" />} data-id="element-18" />
                <Route path="/checkout" element={<CheckoutPage data-id="element-21" />} data-id="element-20" />
              </Routes>
            </div>} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}